export const PERCH_FUNNEL_ID = 'perchEnergy';
export const PERCH_FUNNEL_PATH = '/perch-energy';
export const PERCH_RESUMABLE_STATES = [
  'getEnrollmentOptions',
  'enrollment',
  'scraperFallbackDecider',
  'billingAddress',
  'fetchScraperDetailsValidity',
  'fetchBillingExperienceOptions',
  'lmiZoneVerification',
  'ipaDocumentGroup',
  'contractForm',
  'upload',
  'payment',
  'stripePayment',
  'legal',
  'completed',
] as const;
export const config = {
  id: PERCH_FUNNEL_ID,
  path: PERCH_FUNNEL_PATH,
  show: () => true,
};
